const apiHosts = {
  localhost: 'http://localhost:3010/api',
  'priority2030.my1.urfu.ru': 'https://priority2030-api.my1.urfu.ru/api',
  'priority2030-test.my1.urfu.ru': 'https://priority2030-api-test.my1.urfu.ru/api',
};

const cfg = {
  baseUrl: apiHosts[location.hostname],
  profileUrl: 'https://lk-profile-api.my1.urfu.ru/api'
};
export default cfg;
